module.exports = __webpack_public_path__ + "26235cf613e25e3cc6b89b4cb78e28e0.svg";